/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { CandidateMini } from './candidateMini';
import type { JobMini } from './jobMini';
import type { SequenceMini } from './sequenceMini';
import type { TaskListItemOrigin } from './taskListItemOrigin';
import type { TaskListItemPriority } from './taskListItemPriority';
import type { TaskListItemStatus } from './taskListItemStatus';
import type { TaskListItemType } from './taskListItemType';
import type { UserMini } from './userMini';

/**
 * Compact row payload for the table — matches spec §8.5.
 */
export interface TaskListItem {
  id: string;
  type: TaskListItemType;
  origin: TaskListItemOrigin;
  status: TaskListItemStatus;
  priority: TaskListItemPriority;
  title: string;
  candidate: CandidateMini;
  job?: JobMini | null;
  sequence?: SequenceMini | null;
  creator?: UserMini | null;
  assignee: UserMini;
  due_at?: string | null;
  scheduled_run_at?: string | null;
  completed_at?: string | null;
  is_read: boolean;
  overdue: boolean;
}
